import { render, staticRenderFns } from "./Livechat.vue?vue&type=template&id=298ef778&"
import script from "./Livechat.vue?vue&type=script&lang=js&"
export * from "./Livechat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports